import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ContactPage() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16",
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: "font-display text-5xl text-stone-900 uppercase tracking-wide mb-6",
                children: "Get In Touch"
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "text-stone-600 leading-relaxed mb-8",
                children: "Questions about a product, a custom order, or a wholesale inquiry? Reach out and we'll get back to you."
            }),
            /*#__PURE__*/ _jsxs("form", {
                className: "bg-white border-2 border-stone-100 p-6 space-y-4",
                onSubmit: (e)=>e.preventDefault(),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                htmlFor: "contact-name",
                                className: "block text-xs font-semibold uppercase tracking-wider text-stone-700 mb-1",
                                children: "Name"
                            }),
                            /*#__PURE__*/ _jsx("input", {
                                id: "contact-name",
                                type: "text",
                                className: "w-full border-2 border-stone-200 px-3 py-2 text-sm focus:border-stone-900 focus:outline-none",
                                placeholder: "Your name"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                htmlFor: "contact-email",
                                className: "block text-xs font-semibold uppercase tracking-wider text-stone-700 mb-1",
                                children: "Email"
                            }),
                            /*#__PURE__*/ _jsx("input", {
                                id: "contact-email",
                                type: "email",
                                className: "w-full border-2 border-stone-200 px-3 py-2 text-sm focus:border-stone-900 focus:outline-none",
                                placeholder: "you@example.com"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                htmlFor: "contact-message",
                                className: "block text-xs font-semibold uppercase tracking-wider text-stone-700 mb-1",
                                children: "Message"
                            }),
                            /*#__PURE__*/ _jsx("textarea", {
                                id: "contact-message",
                                className: "w-full border-2 border-stone-200 px-3 py-2 text-sm focus:border-stone-900 focus:outline-none min-h-[120px]",
                                placeholder: "What's on your mind?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        type: "submit",
                        className: "py-3 px-6 bg-stone-900 text-white text-xs font-semibold uppercase tracking-wider hover:bg-stone-700",
                        children: "Send Message"
                    })
                ]
            })
        ]
    });
}
